import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HttpHeadersService } from '../../core/shared-service/http-headers.service';
import {IApproveDenyInput} from './pre-login.model';

@Injectable({
  providedIn: 'root'
})
export class LandingApproveDenyRequestService {

  constructor(private httpclient: HttpClient, private httpHeaderService: HttpHeadersService){}
  post(dataJSON: IApproveDenyInput, approveFlag: boolean): Observable <any>{
    const headers = this.httpHeaderService.preLoginHttpAuthorizationHeader();
    return this.httpclient.post(environment.servicePath + 'sso/request?isRequestApproved=' + approveFlag, dataJSON, { headers});
  }
}
